import React, { Component } from 'react';

import {
  getIcon
} from '../../util/icons';

class ExpiredAssessmentLink extends Component {

  state = {

  }

  render(){
    return (
      <div id="invalid-assessment-link" className="page">
        {getIcon('clock')}
        <h2>Expired Assessment Link</h2>
        <h4>This assessment has been closed.</h4>
        <p>Please verify that you are using the correct link for accessing this assessment.</p>
      </div>
    )
  }
}

export default ExpiredAssessmentLink;



// WEBPACK FOOTER //
// ./src/components/takeAssessment/expiredAssessmentLink.js